module.exports = __webpack_public_path__ + "static/img/08.5b3a978.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/huegler/08.jpg
// module id = 382
// module chunks = 1